"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cleanUpVideoElement", {
  enumerable: true,
  get: function get() {
    return _cleanUpVideoElement["default"];
  }
});
var _cleanUpVideoElement = _interopRequireDefault(require("./cleanUpVideoElement"));